var map = {
	"./close.png": 190,
	"./deezer.png": 269,
	"./heardle.png": 135,
	"./help.png": 713,
	"./info.png": 768,
	"./like.png": 613,
	"./music-note.png": 814,
	"./pause_btn.png": 769,
	"./play_btn.png": 499,
	"./search_icon.png": 906,
	"./skipped.png": 642,
	"./spotify.png": 376,
	"./stats.png": 99,
	"./volume.png": 818,
	"./wrong.png": 485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;